// Persistencia ligera y SÍNCRONA del modo de tema (dark/light).
// Usamos window.localStorage (síncrono) en vez de localforage (async) a propósito:
// necesitamos leer la preferencia ANTES del primer pintado para evitar el flash de
// tema. El backend (settings.theme_mode) es la fuente de verdad entre dispositivos;
// esto es solo el espejo local para arrancar con el tema correcto al instante.

export const THEME_MODES = { dark: 'dark', light: 'light' };
export const DEFAULT_THEME_MODE = THEME_MODES.dark;
const STORAGE_KEY = 'otx_theme_mode';

/**
 * Lee el modo guardado de forma síncrona. Por defecto 'dark'.
 *
 * @returns {'dark'|'light'}
 */
export const getStoredThemeMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === THEME_MODES.light || stored === THEME_MODES.dark
      ? stored
      : DEFAULT_THEME_MODE;
  } catch (error) {
    return DEFAULT_THEME_MODE;
  }
};

/**
 * Guarda el modo en localStorage (síncrono). Silencioso si el storage no está disponible.
 *
 * @param {'dark'|'light'} mode
 */
export const storeThemeMode = (mode) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (error) {
    // storage no disponible (modo privado, etc.) — el estado de Redux sigue funcionando.
  }
};

/**
 * Normaliza un valor arbitrario a un modo válido.
 *
 * @param {*} mode
 * @returns {'dark'|'light'}
 */
export const normalizeThemeMode = (mode) =>
  mode === THEME_MODES.light || mode === THEME_MODES.dark ? mode : DEFAULT_THEME_MODE;
